document.documentElement.classList.remove('no-js');
document.addEventListener('DOMContentLoaded', () => {
  const toggle = document.querySelector('[data-nav-toggle]');
  const nav = document.querySelector('[data-site-nav]');
  if (toggle && nav) {
    toggle.addEventListener('click', () => {
      const open = nav.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(open));
    });
  }
  document.querySelectorAll('[data-product-select]').forEach((select) => {
    const scope = select.closest('.product-main');
    const sync = () => {
      const option = select.options[select.selectedIndex];
      if (!option || !scope) return;
      const price = scope.querySelector('[data-product-price]');
      const button = scope.querySelector('[data-add-to-cart]');
      if (price && option.dataset.price) price.textContent = option.dataset.price;
      if (button) { button.disabled = option.dataset.available !== 'true'; button.textContent = button.disabled ? 'Sold out' : 'Add to cart'; }
      const gallery = scope.querySelector('.product-gallery');
      const media = gallery && Array.from(gallery.children).find(item => item.dataset.mediaId === option.dataset.mediaId);
      if (media) gallery.prepend(media);
    };
    select.addEventListener('change', () => {
      sync();
      const url = new URL(window.location.href);
      url.searchParams.set('variant', select.value);
      window.history.replaceState({}, '', url);
    });
    sync();
  });
});
